var React = require('react');

function LeftChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.305 0a1.384 1.384 0 011.284.858 1.388 1.388 0 01-.301 1.515L3.66 12l9.628 9.628a1.389 1.389 0 11-1.966 1.965L.712 12.983a1.389 1.389 0 010-1.965L11.322.408A1.383 1.383 0 0112.305 0z","fill":"#268dda"}));
}

LeftChevron.defaultProps = {"width":"14","height":"24","fill":"none"};

module.exports = LeftChevron;

LeftChevron.default = LeftChevron;
